import { Type } from "@shared/ui/Type";
import { SupportSearchResults } from "../../support.types";
import SupportSearchFormResultItem from "./SupportSearchFormResultItem";

export type Props = {
  query: string;
  results: SupportSearchResults;
  onArticleResultClick: (article: Article) => void;
};

export function SupportSearchFormResults({
  onArticleResultClick,
  query,
  results,
}: Props) {
  return (
    <div className="max-h-[60vh] overflow-y-auto flex flex-col gap-4 pb-4">
      {Object.entries(results).map(([categoryName, articles]) => (
        <SupportSearchFormResultItem
          key={categoryName}
          categoryName={categoryName}
          articles={articles}
          onArticleClick={onArticleResultClick}
        />
      ))}
      {query && Object.keys(results).length === 0 && (
        <Type variant="body2" className="text-center text-primary-700 py-8">
          No results found for "{query}"
        </Type>
      )}
    </div>
  );
}

export default SupportSearchFormResults;
